import { Injectable, inject } from '@angular/core';
import type { ResponseData } from '@freelancer/freelancer-http';
import { FreelancerHttp } from '@freelancer/freelancer-http';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { firstValueFrom } from 'rxjs';
import { share } from 'rxjs/operators';

export interface BidAwardRevokeReasonsPostRawPayload {
  readonly projectId: number;
  readonly freelancerId: number;
  readonly reasonId: number;
  readonly otherFeedback: string;
}

export interface BidAwardRevokeReasonsPushResultAjax {
  readonly id: number;
  readonly projectId: number;
  readonly freelancerId: number;
  readonly reasonId: number;
  readonly otherFeedback: string;
}

// FIXME: T267853 - What type can this return?
export type BidAwardRevokeReasonsPushErrorAjax = string;

@UntilDestroy({ className: 'BidAwardRevokeReasonService' })
@Injectable({
  providedIn: 'root',
})
export class BidAwardRevokeReasonService {
  private freelancerHttp = inject(FreelancerHttp);

  saveBidAwardRevokeReason(
    revokeReasonRequest: BidAwardRevokeReasonsPostRawPayload,
  ): Promise<
    ResponseData<
      BidAwardRevokeReasonsPushResultAjax,
      BidAwardRevokeReasonsPushErrorAjax
    >
  > {
    const formData = new FormData();
    formData.append('projectId', `${revokeReasonRequest.projectId}`);
    formData.append('freelancerId', `${revokeReasonRequest.freelancerId}`);
    formData.append('reasonId', `${revokeReasonRequest.reasonId}`);
    formData.append('otherFeedback', `${revokeReasonRequest.otherFeedback}`);

    const response$ = this.freelancerHttp
      .post('buyer/saveBidAwardRevokeReason.php', formData, {
        isGaf: true,
      })
      .pipe(share());

    return firstValueFrom(response$.pipe(untilDestroyed(this)));
  }
}
